"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../comps/reusables");
const react_2 = require("@osmosys/react");
const graphql_1 = require("../../../../graphql");
const Yup = tslib_1.__importStar(require("yup"));
const ContentFeedListDetail_1 = require("./ContentFeedListDetail");
const react_hanger_1 = require("react-hanger");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const inputs_1 = require("../../../../inputs");
exports.ContentFeedList = ({ integration }) => {
    const { history } = use_react_router_1.default();
    const { state, setState } = react_hanger_1.useSetState({
        archived: false,
    });
    return (react_1.default.createElement(reusables_1.QueryList, { queryProps: {
            fetchPolicy: 'cache-and-network',
            query: graphql_1.contentFeedsList,
        }, queryVariables: {
            archived: state.archived,
            cmsId: integration.id,
        }, item: ContentFeedListDetail_1.ContentFeedListDetail, toolbarLeft: react_1.default.createElement("strong", null,
            state.archived ? 'Archived content feeds' : 'Active content feeds',
            ' ',
            react_1.default.createElement(react_2.OsmosysTooltip, { label: state.archived ? 'Show active feeds' : 'Show archived feeds', span: true },
                react_1.default.createElement(reactstrap_1.Button, { size: "sm", color: "link", className: "text-dark p-0 font-weight-bold", onClick: () => {
                        setState({
                            archived: !state.archived,
                        });
                    } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: state.archived ? pro_solid_svg_icons_1.faTimesCircle : pro_solid_svg_icons_1.faArchive })))), itemName: "content feed", itemsKey: "contentFeeds", countKey: "contentFeedsCount", itemURL: data => `/integrations/${integration.id}/feeds/${data.id}`, showNewBtn: true, form: (refetch, close, refetchInfo) => (react_1.default.createElement(reusables_1.Form, { mutationProps: {
                awaitRefetchQueries: true,
                mutation: graphql_1.createContentFeed,
                onCompleted: data => {
                    setTimeout(() => {
                        history.push(data.createContentFeed.resourceEndpoint);
                    }, 600);
                },
                refetchQueries: [refetchInfo],
            }, valuesToVariables: values => {
                var _a;
                return {
                    cmsId: integration.id,
                    data: {
                        contentMappingId: (_a = values.contentMapping) === null || _a === void 0 ? void 0 : _a.id,
                        contentPushIsEnabled: values.contentPushIsEnabled,
                        name: values.name,
                        url: values.url || null,
                    },
                };
            }, formikProps: {
                initialValues: {
                    contentMapping: null,
                    contentPushIsEnabled: false,
                    name: '',
                    url: '',
                },
                validationSchema: Yup.object().shape({
                    contentPushIsEnabled: Yup.boolean(),
                    name: Yup.string().required('Required'),
                    url: Yup.string().url(),
                }),
            } }, (formikProps, mutationResult) => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(reusables_1.FormGroup, { label: "Name", name: "name", placeholder: "My Great Blog Posts Endpoint" }),
            react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { resource: "contentMapping", cmsId: integration.id, value: formikProps.values.contentMapping, onChange: (cm) => formikProps.setFieldValue('contentMapping', cm), boldLabel: true }),
            react_1.default.createElement(react_2.OsmosysToggler, { id: "contentPushIsEnabled", offLabel: "Pull content from CMS, RSS, or API", onLabel: "Push content to Osmosys", on: formikProps.values.contentPushIsEnabled, toggle: on => formikProps.setFieldValue('contentPushIsEnabled', on), boldLabel: true }, "Content source type"),
            react_1.default.createElement(reactstrap_1.Collapse, { isOpen: !formikProps.values.contentPushIsEnabled },
                react_1.default.createElement(reusables_1.FormGroup, { label: "Request URL", name: "url", type: "url", placeholder: "https://example-api.com/posts.json" })),
            react_1.default.createElement(reusables_1.AjaxButton, { type: "submit", disabled: formikProps.isSubmitting || !formikProps.dirty, loading: mutationResult.loading, error: mutationResult.error, success: !!mutationResult.data, label: "Add content feed", onClick: () => {
                    formikProps.handleSubmit();
                } }),
            react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "ContentFeed", action: "create", apolloError: mutationResult.error }))))) }));
};
//# sourceMappingURL=ContentFeedList.js.map